export default class AdfFooterLinks
{
    constructor ()
    {
        this.btnUser          = document.querySelector( "#header-link-user" )
        this.btnMenuShowLogin = document.querySelectorAll( "[data-show-login]" )
        if ( this.btnMenuShowLogin.length > 0 )
        {
            this.bindFooterLinksEvents( this.btnMenuShowLogin );
        }

        this.footerLinksNeedingLogin = document.querySelectorAll( '#footer a.must-login' );
        if ( this.footerLinksNeedingLogin.length > 0 )
        {
            this.bindFooterLinksEvents( this.footerLinksNeedingLogin );
        }

    }


    bindFooterLinksEvents ( arr )
    {
        Array.from( arr ).forEach( ( el, i ) =>
        {
            el.addEventListener( 'click', ( e ) =>
            {

                if ( window?.__USER__ === null ?? true )
                {

                    e.preventDefault();

                    this.showUserModal();
                }
            } );
        } );


        this.btnUser.addEventListener( 'click', this.onBtnUserClick.bind( this ) );
    }


    onBtnUserClick ( e )
    {
        e.preventDefault();
        this.showUserModal();
    }

    showUserModal ()
    {

        let isLogin = false;

        if ( !this.userDialog ) //first time
        {
            this.userDialog = document.querySelector( "#dialog_login" );

            this.userDialog.addEventListener( "mousedown", ( e ) =>
            {
                let target     = e.target;
                let id         = target.id ?? "";
                let closestDiv = e.target.closest( "div" );

                if ( !closestDiv && id === "dialog_login" )
                {
                    this.clickDown = e.target;
                }


            } );


            this.userDialog.addEventListener( "click", ( e ) =>
            {
                let target     = e.target;
                let id         = target.id ?? "";
                let closestDiv = e.target.closest( "div" );


                //clicking on the backdrop let us close the modal
                if ( !closestDiv && id === "dialog_login" && this.clickDown )
                {
                    window.__login__.close();
                }

                this.clickDown = null;
            } )
        }

        if ( window.__login__ )
        {
            window.__login__.init();
        }

        this.userDialog.showModal();

    }
}
